import Api from './api';
export const getCategories = async () => { 
  let data = [];
  await Api.get('/categories')
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

export const getCanEditAccompanimentInActiveCalledByOrgId = async (orgId) => { 
  let data = []
  await Api.get(`/organizationsettings/caneditaccompanimentinactivecalled/${orgId}`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const getTechinicalTeamsByOrganizationId = async (orgId) => {
  let data = []
  await Api.get(`/techinicalteams/organization/${orgId}/withoutincludes`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
  });
  return data
}

export const getAllByOrganizationIdSelectionModel = async (orgId) => {
  let data = []
  await Api.get(`/techinicalteams/organization/${orgId}/selectionmodel`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
  });
  return data
}

export const getAllItemsSelectionModel = async (orgId) => {
  let data = []
  await Api.get(`/techinicalteams/all/selectionmodel`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
  });
  return data
}
  
export const getAllCategoriesWithParent = async () => {
  let data = [];
  await Api.get("/categories/parent")
      .then(result => {
          data = result.data
      })
      .catch(err => {
          data = err;
      });
  return data;
};

export const getByOrganizationIdDapper = async (orgId) => {
  let data = []
  await Api.get(`/performance/organizationsettings/organization/${orgId}`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
  });
  return data
}

export const getByOrganizationWithoutIncludes = async (orgId) => {
  let data = []
  await Api.get(`/organizationsettings/organization/${orgId}/withoutincludes`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
  });
  return data
}

export const getOrganizations = async (id = 0) => { 
  let data = [];
  if(id != 0 && id != null && id != NaN){
    await Api.get(`/organizationsettings/organizations/${id}`)
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
    });
  }else{
    await Api.get('/organizations')
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
    });
  }
  
  return data;
};

export const getSlas = async () => { 
  let data = [];
  await Api.get('/slas')
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

export const getTypes = async () => { 
  let data = [];
  await Api.get('/types')
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

export const getOriginRequests = async () => { 
  let data = [];
  await Api.get('/originrequests')
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

export const getOriginRequestsByFlag = async () => { 
  let data = [];
  await Api.get('/originrequests/byflag')
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

export const getStatuses = async () => { 
  let data = [];
  await Api.get('/statuses')
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

export const GetDisabledCallRejectionByRequesterByOrganization = async (orgId) => { 
  let data = [];
  await Api.get(`/organizationsettings/disabledcallrejection/organization/${orgId}`)
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

